import { SET_NOTIFICATION, UNSET_NOTIFICATION } from '../constants';

let lastTimeout = null;

export function setNotification(notification) {
    if (notification && notification.name) {
        switch (notification.name) {
            case 'action': {
                notification.dismissTimer = 5; //TODO: change this dismiss timer when final values available for the different types of notifications
                break;
            }
            default: {
                notification.dismissTimer = undefined;
                break;
            }
        }
    }
    return (dispatch) => {
        dispatch({ type: SET_NOTIFICATION, data: notification });
        clearTimeout(lastTimeout);
        if (notification.dismissTimer) {
            lastTimeout = setTimeout(() => {
                dispatch({ type: UNSET_NOTIFICATION });
            }, notification.dismissTimer * 1000);
        }
    };
}
